"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrayLikeObservable = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Observable2 = require("../Observable");

var _ScalarObservable = require("./ScalarObservable");

var _EmptyObservable = require("./EmptyObservable");

/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable =
/*#__PURE__*/
function (_Observable) {
  (0, _inherits2.default)(ArrayLikeObservable, _Observable);

  function ArrayLikeObservable(arrayLike, scheduler) {
    var _this;

    (0, _classCallCheck2.default)(this, ArrayLikeObservable);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ArrayLikeObservable).call(this));
    _this.arrayLike = arrayLike;
    _this.scheduler = scheduler;

    if (!scheduler && arrayLike.length === 1) {
      _this._isScalar = true;
      _this.value = arrayLike[0];
    }

    return _this;
  }

  (0, _createClass2.default)(ArrayLikeObservable, [{
    key: "_subscribe",
    value: function _subscribe(subscriber) {
      var index = 0;
      var arrayLike = this.arrayLike,
          scheduler = this.scheduler;
      var length = arrayLike.length;

      if (scheduler) {
        return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
          arrayLike: arrayLike,
          index: index,
          length: length,
          subscriber: subscriber
        });
      } else {
        for (var i = 0; i < length && !subscriber.closed; i++) {
          subscriber.next(arrayLike[i]);
        }

        subscriber.complete();
      }
    }
  }], [{
    key: "create",
    value: function create(arrayLike, scheduler) {
      var length = arrayLike.length;

      if (length === 0) {
        return new _EmptyObservable.EmptyObservable();
      } else if (length === 1) {
        return new _ScalarObservable.ScalarObservable(arrayLike[0], scheduler);
      } else {
        return new ArrayLikeObservable(arrayLike, scheduler);
      }
    }
  }, {
    key: "dispatch",
    value: function dispatch(state) {
      var arrayLike = state.arrayLike,
          index = state.index,
          length = state.length,
          subscriber = state.subscriber;

      if (subscriber.closed) {
        return;
      }

      if (index >= length) {
        subscriber.complete();
        return;
      }

      subscriber.next(arrayLike[index]);
      state.index = index + 1;
      this.schedule(state);
    }
  }]);
  return ArrayLikeObservable;
}(_Observable2.Observable);

exports.ArrayLikeObservable = ArrayLikeObservable;